module.exports = __webpack_public_path__ + "img/eg10.673c8623.png";